import UserContentHeader from "../../header/usercontentheader/usercontentheader";
import Button from "../../../../core/button/button";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import "./campaigns.scss"
import Table from "../../../../ui/table/table";
import {SimpleTable} from "../../../../modals/types/table";
import Toggle from "../../../../ui/toggle/toggle";
import ThreeDotsIcon from "../../../../modules/icons/threedots";
import ButtonDropdownMenu from "../../../../ui/dropdownmenu/buttondropdownmenu/buttondropdownmenu";
import ReportIcon from "../../../../modules/icons/report";
import EditIcon from "../../../../modules/icons/edit";
import DetailsIcon from "../../../../modules/icons/details";
import TableHeaderContent from "../../../../ui/tableheadercontent/tableheadercontent";

const Campaigns = () => {
    const contentHeaderBox: JSX.Element = (
        <Button type={"secondary"} action={() => {
        }} responsive={true}>
            <AddCircleOutlineOutlinedIcon/>
            &nbsp;&nbsp;
            ایجاد کمپین جدید
        </Button>
    )
    const buttonDropMenu = (
        [
            {
                icon: <ReportIcon/>, title: 'گزارش', action: () => {
                }
            },
            {
                icon: <EditIcon/>, title: 'ویرایش', action: () => {
                }
            },
            {
                icon: <DetailsIcon/>, title: 'جزئیات', action: () => {
                }
            },
        ]
    )
    const tableData: SimpleTable = {
        headers: ["شناسه", "عنوان", "نوع", "هزینه", "مصرف روزانه", "مصرف کل", "تاریخ", "وضعیت", "فعالیت", "عملیات"],
        bodies: [
            ["1793", "کمپین روز مادر", "شبکه اجتماعی-استانی", "100 میلیون تومان", "50 هزار تومان", "۵۰ میلیون تومان", "1401/10/23",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["1071", "موبایل سامسونگ", "همسان-بنری", "10 میلیون تومان", "50 هزار تومان", "2 هزار", "1401/10/23",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5380", "نوتیف/مشهد/موبایل", "ویدیویی-همسان", "20 میلیون تومان", "1 میلیون تومان", "2 هزار", "1401/10/23",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5389", "لپ تاپ", "محصول", "7 میلیون تومان", "2 هزار", "1 میلیون تومان", "1401/10/23",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5387", "کت چرم", "تیزر استانی", "7 میلیون تومان", "1 میلیون تومان", "2 هزار", "1401/10/23",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5391", "تخفیف دوره ای", "گوگل", "10 میلیون تومان", "1 میلیون تومان", "2 هزار", "1401/10/23",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5393", "نوتیف/تهران/موبایل و دسکتاپ", "رپورتاژ آکهی", "20 میلیون تومان", "1 میلیون تومان", "2 هزار", "1401/10/23",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["4148", "بنر فروش فوق‌العاده", "شبکه اجتماعی", "50 میلیون تومان", "1 میلیون تومان", "2 هزار", "1401/10/23",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
        ]
    }
    return (
        <div className="User-Campaigns">
            {/*<DataNotFound image={require("../../../assets/images/icons/DataNotFound2.svg").default}*/}
            {/*              title={"شما هیچ کمپینی ندارید ):"}*/}
            {/*              body={"برای شروع کار یک کمپین بسازید. کمپین ها به شما کمک می کنند که تبلیغات خود را \n" +*/}
            {/*                  "به آسانی  و با شرایطی که میخواهید ، نمایش دهید."}/>*/}
            {/*<RangePicker />*/}
            <>
                <UserContentHeader title={'کمپین های من'}
                                   subtitle={"در لیست زیر می توانید تمام کمپین های خود را مشاهده کنید."} icon={<></>}
                                   iconColor={"#EF233C"}
                                   box={contentHeaderBox}/>
                <Table
                    headers={tableData.headers}
                    bodies={tableData.bodies}
                    headerContent={<TableHeaderContent title={"همه کمپین ها"} subtitle={" ۸ کمپین"}
                                                       placeholder={"جستجوی کمپین"} onClick={() => {
                    }}/>}
                    rowEachPage={8}/>
            </>
        </div>
    )
}

export default Campaigns